import { IconErrorOutlined } from '@prisjakt/ui/icon/error-outlined';
import { BodySmallText, FontEmphasis } from '@prisjakt/ui/text/variants';
import type { ReactNode } from 'react';
import React from 'react';
import { Message, MessageGroup, MessageWrapper } from './styles';

export type InfoMessageType = {
  text: string;
  link: ReactNode;
};

type InfoMessageProps = {
  message: InfoMessageType;
};

export const InfoMessage = ({ message }: InfoMessageProps) => {
  return (
    <MessageWrapper>
      <IconErrorOutlined />
      <MessageGroup>
        <Message>
          <BodySmallText emphasis={FontEmphasis.MEDIUM}>
            {message.text}
          </BodySmallText>
          {message.link || null}
        </Message>
      </MessageGroup>
    </MessageWrapper>
  );
};
